import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { ShiftValidationDetails } from '@wilson/interfaces';
import { ValidationDataSourceService } from '@wilson/shift-timeline/assignments-gantt-chart';
import { Observable, of } from 'rxjs';

@Injectable()
export class FindStaffValidationDataSourceService extends ValidationDataSourceService {
  private store = inject(Store);

  override hasShiftValidated(shiftId: string): Observable<boolean> {
    return of(false);
  }

  override isShiftOfUserValidated(): Observable<boolean> {
    return of(false);
  }

  override isCurrentUserValidationLoading(): Observable<boolean> {
    return of(false);
  }

  override shiftValidationStreamForAssignedShifts(
    shiftId: string,
  ): Observable<ShiftValidationDetails[] | undefined> {
    return of([]);
  }

  override shiftValidationStreamForUnassignedShifts(
    shiftId: string,
  ): Observable<ShiftValidationDetails[] | undefined> {
    return of([]);
  }

  override isLoadingValidationsError(): Observable<boolean> {
    return of(false);
  }

  override isLoadingValidationsV1Error(): Observable<boolean> {
    return of(false);
  }

  override isShiftValidationLoadingForAssignedShifts(
    shiftId: string,
  ): Observable<boolean> {
    //TODO: connect this with a new modal validationstate
    return of(false);
  }

  override isShiftValidationLoadingForUnassignedShifts(
    shiftId: string,
  ): Observable<boolean> {
    //TODO: connect this with a new modal validationstate
    return of(false);
  }
}
